import axios from 'axios';
import { logoutPost } from 'store/auth/authDataSlice';
const CryptoJS = require("crypto-js");
export const baseURL = process.env.REACT_APP_BASE_URL;
export const imageURL = process.env.REACT_APP_BASE_URL_ASSET;
export const imageToken = process.env.REACT_APP_BASE_URL_ASSET_TOKEN
const currentExecutingRequests: any = {};

/**
 * Define interceptor to handle api resoponse and set header value
 */
const InterceptorApi = (store: any) => {

    axios.interceptors.request.use(function (req: any) {
        let originalRequest: any = req;
        if (!originalRequest?.headers?.deniedCancle && currentExecutingRequests[originalRequest.url]) {
            const source = currentExecutingRequests[originalRequest.url];
            delete currentExecutingRequests[originalRequest.url];
            source.cancel();
        }

        if (originalRequest?.url !== "save-url" && originalRequest?.url !== process.env.REACT_APP_FUNCTIONAL_URL)  {
            const CancelToken = axios.CancelToken;
            const source = CancelToken.source();
            originalRequest.cancelToken = source.token;
            currentExecutingRequests[originalRequest.url] = source;

        }

        // here you could add the authorization header to the request

        // return originalRequest;
        return { ...originalRequest, baseURL: baseURL };
    }, (error: any) => {
        return Promise.reject(error);
    })
    axios.interceptors.response.use((response: any) => {
        if (response?.data && !Array.isArray(response?.data)) {
            const bytes = CryptoJS.AES.decrypt(response?.data?.data, process.env.REACT_APP_EN_KEY);
            const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            return { ...response, data: { ...response.data, data: decryptedData } };
        }
        else {
            return response
        }
    }, (error: any) => {
        if (error?.response?.data?.authorized === false) {

            for (const [key] of Object.entries(currentExecutingRequests)) {
                const source = currentExecutingRequests[key];
                delete currentExecutingRequests[key];
                source.cancel();
            }

            store.dispatch(logoutPost())
        }
        return Promise.reject(error);
    })
}
export default InterceptorApi